import { IntlShape } from 'react-intl';

export function getDocFromPathname(pathname: string, intl: IntlShape) {
  switch (pathname) {
    case 'legacy':
      return {
        code: 'user_agreement',
        name: intl.formatMessage({ id: 'SUBMENU.LEGAL_TERMS' }),
      };
    case 'commission':
      return {
        code: 'marketplace_commission',
        name: intl.formatMessage({ id: 'SUBMENU.MARKETPLACE.COMMISSION' }),
      };
    case 'marketplace_commission':
      return {
        code: 'marketplace_commission',
        name: intl.formatMessage({ id: 'SUBMENU.MARKETPLACE.COMMISSION' }),
      };
    case 'privacy':
      return {
        code: 'privacy_policy',
        name: intl.formatMessage({ id: 'SUBMENU.LEGAL_PRIVACY' }),
      };
    case 'privacy_policy':
      return {
        code: 'privacy_policy',
        name: intl.formatMessage({ id: 'SUBMENU.LEGAL_PRIVACY' }),
      };
    case 'shipping':
      return {
        code: 'shipping_policy',
        name: intl.formatMessage({ id: 'SUBMENU.LEGAL_SHIPPING' }),
      };
    case 'refund':
      return {
        code: 'refund_policy',
        name: intl.formatMessage({ id: 'SUBMENU.LEGAL_REFUND' }),
      };

    case 'public_offer':
      return {
        code: 'public_offer',
        name: intl.formatMessage({ id: 'PUBLIC.OFFER' }),
      };

    case 'import_instruction':
      return {
        code: 'import_instruction',
        name: intl.formatMessage({ id: 'SUBMENU.IMPORT.INSTRUCTION' }),
      };

    case 'cookie_policy':
      return {
        code: 'cookie_policy',
        name: intl.formatMessage({ id: 'DOC.COOKIE_POLICY' }),
      };

    default:
      return {
        code: 'user_agreement',
        name: intl.formatMessage({ id: 'DOC.USER_AGREEMENT' }),
      };
  }
}
